import React from "react";

const Particles = () => {
  return (
    <div className="particles-container">
      {/* Blue particles */}
      <div className="particle"></div>
      <div className="particle"></div>
      <div className="particle large"></div>
      <div className="particle"></div>
      <div className="particle"></div>
      
      {/* Purple particles */}
      <div className="particle purple"></div>
      <div className="particle purple large"></div>
      <div className="particle purple"></div>
      <div className="particle purple"></div>
      <div className="particle purple"></div>
      
      {/* Cyan particles */}
      <div className="particle cyan"></div>
      <div className="particle cyan"></div>
      <div className="particle cyan large"></div>
      <div className="particle cyan"></div>
      <div className="particle cyan"></div>
      
      {/* Extra particles */}
      <div className="particle"></div>
      <div className="particle purple"></div>
      <div className="particle cyan"></div>
      <div className="particle large"></div>
      <div className="particle purple large"></div>
    </div>
  );
};

export default Particles;
